'use client';

import { useI18n } from '@/contexts/I18nContext';
import { useEditorStore } from '@/lib/editor/editorStore';
import { VIDEO_FILTERS } from '@/lib/editor/filters';

/** Color-grade picker for the currently selected video clip. */
export function FiltersPanel() {
  const { t } = useI18n();
  const selectedClipId = useEditorStore((s) => s.selectedClipId);
  const selectedClip = useEditorStore((s) => s.clips.find((clip) => clip.id === s.selectedClipId));
  const filterId = selectedClip?.filterId ?? 'none';
  const setFilter = useEditorStore((s) => s.setFilter);

  return (
    <div className="flex h-full min-h-0 flex-col bg-[#121214] text-white">
      <div className="flex h-10 shrink-0 items-center border-b border-white/10 px-3.5">
        <p className="text-sm font-semibold">{t('studio.editor.toolFilters')}</p>
      </div>

      <div data-lenis-prevent className="min-h-0 flex-1 overflow-y-auto p-3">
        {selectedClip ? (
          <div className="rounded-lg border border-white/10 bg-black/15 px-2.5 py-2">
            <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-white/35">Выбранное видео</p>
            <p className="mt-1 truncate text-xs font-semibold text-white/75">{selectedClip.title}</p>
          </div>
        ) : (
          <div className="rounded-xl border border-dashed border-white/15 px-3 py-5 text-center text-xs leading-5 text-white/50">
            Выберите видео на таймлайне, чтобы применить фильтр только к нему.
          </div>
        )}

        <div className={`mt-3 grid grid-cols-2 gap-2 ${selectedClipId ? '' : 'pointer-events-none opacity-40'}`}>
          {VIDEO_FILTERS.map((preset) => {
            const active = preset.id === filterId;
            return (
              <button
                key={preset.id}
                type="button"
                disabled={!selectedClipId}
                onClick={() => setFilter(preset.id)}
                className={`flex flex-col items-center gap-2 rounded-xl border px-2 py-2.5 text-center transition ${
                  active
                    ? 'border-brand-400 bg-brand-600/30 text-white ring-2 ring-brand-400/70'
                    : 'border-white/10 bg-white/5 text-white/70 hover:border-brand-500 hover:text-brand-300'
                }`}
              >
                <span
                  aria-hidden="true"
                  className="h-9 w-full rounded-lg bg-[linear-gradient(135deg,#5b35ff_0%,#ff9f6e_45%,#6ee7ff_100%)]"
                  style={preset.css ? { filter: preset.css } : undefined}
                />
                <span className="text-[11px] font-bold leading-tight">{preset.name}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
